import { render } from "./SwitchDevices.vue?vue&type=template&id=304a9608&ts=true"
import script from "./SwitchDevices.vue?vue&type=script&lang=ts"
export * from "./SwitchDevices.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__